// All in gets 2 args : balance, max stake
// returns which is more
import floorFigure from 'components/header/mainHeader/helpers/floorFigure'

export const allIn = (
  balance: string,
  maxStake: string,
  minStake: string,
  toFix: number,
) => {
  // console.log("floorFigure(maxStake, toFix)", floorFigure(maxStake, toFix))
  return +balance >= +maxStake
    ? floorFigure(maxStake, toFix)
    : +balance < +minStake
    ? floorFigure(minStake, toFix)
    : floorFigure(balance, toFix)
}
